import { render } from "./EditSupplierPage.vue?vue&type=template&id=46b233fb"
import script from "./EditSupplierPage.vue?vue&type=script&lang=js"
export * from "./EditSupplierPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__